import {TypeOf} from 'io-ts';
import {BaseCurrencyCode} from './BaseCurrencyCode';

export const FiatCurrencyCode = BaseCurrencyCode;
export type FiatCurrencyCode = TypeOf<typeof FiatCurrencyCode>;
